var $659de19a00ff9617$exports = {};
$659de19a00ff9617$exports = {
    "breadcrumbs": `Nar\u{161}ymo kelias`
};


export {$659de19a00ff9617$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
